import { RSAA } from 'redux-api-middleware';
import TELEMETRY_API from '../../config/api';

export const WORK_LOCATIONS_REQUEST = 'WORK_LOCATIONS_REQUEST';
export const WORK_LOCATIONS_SUCCESS = 'WORK_LOCATIONS_SUCCESS';
export const WORK_LOCATIONS_FAILURE = 'WORK_LOCATIONS_FAILURE';

export const WORK_LOCATION_DETAILS_REQUEST = 'WORK_LOCATION_DETAILS_REQUEST';
export const WORK_LOCATION_DETAILS_SUCCESS = 'WORK_LOCATION_DETAILS_SUCCESS';
export const WORK_LOCATION_DETAILS_FAILURE = 'WORK_LOCATION_DETAILS_FAILURE';

export const WORK_LOCATION_CREATE_REQUEST = 'WORK_LOCATION_CREATE_REQUEST';
export const WORK_LOCATION_CREATE_SUCCESS = 'WORK_LOCATION_CREATE_SUCCESS';
export const WORK_LOCATION_CREATE_FAILURE = 'WORK_LOCATION_CREATE_FAILURE';

export const WORK_LOCATION_UPDATE_REQUEST = 'WORK_LOCATION_UPDATE_REQUEST';
export const WORK_LOCATION_UPDATE_SUCCESS = 'WORK_LOCATION_UPDATE_SUCCESS';
export const WORK_LOCATION_UPDATE_FAILURE = 'WORK_LOCATION_UPDATE_FAILURE';

export function requestWorkLocations(params = {}) {
  const query = $.param(params, true);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/work/locations?${query}`,
      method: 'GET',
      types: ['WORK_LOCATIONS_REQUEST', 'WORK_LOCATIONS_SUCCESS', 'WORK_LOCATIONS_FAILURE']
    }
  };
}

export function requestWorkLocationDetails(workLocationId, params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/work/locations/${workLocationId}?${query}`,
      method: 'GET',
      types: [
        { type: 'WORK_LOCATION_DETAILS_REQUEST', meta: { workLocationId } },
        { type: 'WORK_LOCATION_DETAILS_SUCCESS', meta: { workLocationId } },
        { type: 'WORK_LOCATION_DETAILS_FAILURE', meta: { workLocationId } },
      ]
    }
  }
}

export function createWorkLocation(workLocation, params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/work/locations?${query}`,
      method: 'POST',
      body: JSON.stringify(workLocation),
      types: ["WORK_LOCATION_CREATE_REQUEST", "WORK_LOCATION_CREATE_SUCCESS", "WORK_LOCATION_CREATE_FAILURE"]
    }
  }
}

export function updateWorkLocation(workLocation, params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/work/locations?${query}`,
      method: 'PUT',
      body: JSON.stringify(workLocation),
      types: ["WORK_LOCATION_UPDATE_REQUEST", "WORK_LOCATION_UPDATE_SUCCESS", "WORK_LOCATION_UPDATE_FAILURE"]
    }
  }
}

export function deleteWorkLocation(workLocationId, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/work/locations/${workLocationId}/deactivate?${query}`,
      method: 'PUT',
      types: ["WORK_LOCATION_DELETE_REQUEST", "WORK_LOCATION_DELETE_SUCCESS", "WORK_LOCATION_DELETE_FAILURE"]
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/work-location-manager/WorkLocationManagerActions.js